<ng-container *ngIf="batch">
    <app-mixer [batch]="batch"> </app-mixer>
  </ng-container>